import { post } from "src/services/api";

export const getPolicyCrossReferenceData = async (assistantId, policyIds) => {
  if (!assistantId) {
    throw new Error("assistantId is required for fetching policy cross-reference data");
  }

  if (!policyIds || !Array.isArray(policyIds) || policyIds.length === 0) {
    return [];
  }

  return await post({
    endpoint: `v2/assistants/${assistantId}/collections/cross-references/policies/query`,
    data: {
      ids: policyIds
    }
  });
};

// Needed for Cypress tests, remove after
export default {
  getPolicyCrossReferenceData
};
